module.exports = __webpack_public_path__ + "img/login-user.62461143.svg";